import { z } from 'zod';

/**
 * Единая точка конфигурации короткого кода для код-входа (work-019, ask-by-code).
 *
 * Расширение = правка ОДНОЙ константы здесь:
 *   length: 5  → 100 000 вариантов
 *   alphabet без похожих: '23456789ABCDEFGHJKLMNPQRSTUVWXYZ'
 *
 * Browser-safe: без node:crypto. Генерация — в apps/api/src/lib/codeGen.ts.
 */
export const CODE_CONFIG = {
  length: 4,
  alphabet: '0123456789',
} as const;

/**
 * Экранирует строку для безопасного использования внутри символьного класса regex [...].
 * Каждый символ, имеющий специальное значение внутри класса, экранируется обратным слешем.
 * Сейчас алфавит = цифры (безопасны), но код должен пережить будущие алфавиты с буквами
 * и спецсимволами (например ']', '-', '^', '\').
 */
function escapeForCharClass(str: string): string {
  // Символы со спецзначением внутри [...]: ] \ ^ -
  return str.replace(/[\]\\^-]/g, '\\$&');
}

/**
 * Zod-схема валидации кода: строка ровно CODE_CONFIG.length символов из CODE_CONFIG.alphabet.
 * Регэксп строится динамически из конфига — изменение alphabet/length автоматически
 * подхватывается валидацией и генерацией.
 */
export const codeSchema = z
  .string()
  .regex(
    new RegExp(
      `^[${escapeForCharClass(CODE_CONFIG.alphabet)}]{${CODE_CONFIG.length}}$`,
    ),
    `Code must be exactly ${CODE_CONFIG.length} characters from alphabet "${CODE_CONFIG.alphabet}"`,
  );

export type CodeSchema = z.infer<typeof codeSchema>;
